(function () {
  'use strict';
  if (window.__evmDeferredImagesBooted) {
    if (window.evmHydrateImages) window.evmHydrateImages(document);
    return;
  }
  window.__evmDeferredImagesBooted = true;

  var observer = null;

  function loadImage(img) {
    var src = img.getAttribute('data-evm-src');
    if (!src) return;
    img.removeAttribute('data-evm-src');
    img.decoding = 'async';
    img.src = src;
  }

  function hydrate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var images = scope.querySelectorAll('img[data-evm-src]');
    Array.prototype.forEach.call(images, function (img) {
      if (observer) observer.observe(img);
      else loadImage(img);
    });
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        loadImage(entry.target);
      });
    }, { rootMargin: '500px 0px' });
  }

  window.evmHydrateImages = hydrate;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(document); }, { once: true });
  } else {
    hydrate(document);
  }
})();
